import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiSetting } from 'Services/AuthService'

export const getSetting = createAsyncThunk('setting/getSetting', async guard => {
    const { data } = await apiSetting(guard)
    return data
})

export const settingSlice = createSlice({
    name: 'setting',
    initialState: null,
    extraReducers: builder => {
        builder.addCase(getSetting.fulfilled, (_, action) => action.payload)
        builder.addCase(getSetting.rejected, _ => null)
    },
})

export default settingSlice.reducer
